import React from 'react';
import { useState } from 'react';
import InfoTooltip from '../infoTooltip/infoTooltip.js';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { postData } from '../../functions/postData.js';
import { create, all } from 'mathjs';
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Icon from '@mdi/react';
import { mdiCashMultiple } from '@mdi/js';
import { _ } from '../../functions/translator.js';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { CircularProgress } from '@material-ui/core'

function AddCosts(props){
    const {visibleCardsGroupIds, selectedCardsGroups} = useSelector(state => ({
        visibleCardsGroupIds: state.visibleCardsGroupIds,
        selectedCardsGroups: state.selectedCardsGroups
    }))
    const [show, setShow] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [showSuccesToast, setShowSuccessToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);
    const [showFailureFormula, setShowFailureFormula] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleCheckChange = () => {
        setIsChecked(!isChecked);
      };

    function validateFormula(formula) {
        const math = create(all);
        try {
            math.parse(formula);
            return formula;
        } catch (error) {
            return false;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowLoading(true)
        try {
            const formData = new FormData(e.target);
            const unit = formData.get('unit');
            const input_type = formData.get('input_type');
            const cost_amount = parseFloat(formData.get('cost_amount'));
            const formula = validateFormula(formData.get('formula'));
            const searchParams = new URLSearchParams(window.location.search);
            const project_id = searchParams.get('project_id');
            const total_quantity = formData.get('check') === "on"? null: parseFloat(formData.get('total_quantity'))

            const urlPost = {
                cards_group_ids: selectedCardsGroups === "none"? visibleCardsGroupIds : selectedCardsGroups,
                project_id,
                unit,
                formula,
                input_type,
                cost_amount,
                total_quantity
            };
            
            if(!formula){
                setShowFailureFormula(true)
            } else {
                const response = await postData('/web-api/input-cards-groups-costs', urlPost, 'Error en la solicitud');
                if (response.status === 'success') {
                    setShowSuccessToast(true);
                } else {
                    setShowFailureToast(true);
                }
            }

        } catch (error) {
            console.error('Error:', error);
            setShowFailureToast(true);
        } finally {
            setShowLoading(false)
        }
    };

    return(
        <>
            {props.popUpMenu===true?
            <div className='w-100' onClick={handleShow}>
                <div className='d-inline-flex'>
                    <Icon path={ mdiCashMultiple } size='30px' color='white' style={{margin: 10}}/>
                    <p>{ _('Añadir Costos') }</p>
                </div>
            </div>
            :<Button 
                onClick={handleShow} 
                size='small' 
                style={{width:'100%', background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700}}>
                <div className='d-flex flex-row'>
                    <Icon path={mdiCashMultiple} size={1} className='mr-2'/>
                    <p style={{fontFamily:'Rubik', margin:'0px'}}>{ _('Añadir Costos') }</p>
                </div>
            </Button>}
            
            
            <Modal show={show} onHide={handleClose} className="fade" style={{fontFamily:"Rubik"}}>
                <Modal.Header>
                    <p style={{fontFamily:'Rubik' , margin:'0px', }}>{ _('Añadir Costos') }</p>
                    <div className='close-button text-md' onClick={handleClose}>
                        x
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Snackbar 
                        className='w-100 p-0' 
                        onClose={() => setShowSuccessToast(false)} 
                        open={showSuccesToast} 
                        autoHideDuration={4000}>
                            <MuiAlert elevation={6} variant="filled" severity="success">
                                <div className='text-center w-100 m-0'>
                                    {selectedCardsGroups === "none"?
                                    <p>¡{_('Se han agregado costos a')} {visibleCardsGroupIds.length} {_('registros exitosamente')}!</p>
                                    :<p>¡{_('Se han agregado costos a')} {selectedCardsGroups.length} {_('registros exitosamente')}!</p>}
                                </div>
                            </MuiAlert>
                    </Snackbar>
                    <Snackbar 
                        className='w-100 p-0' 
                        onClose={() => setShowFailureToast(false)} 
                        open={showFailureToast} 
                        autoHideDuration={4000}>
                            <MuiAlert elevation={6} variant="filled" severity="error">
                                <p className='text-center w-100 m-0'>¡{_('Ha ocurrido un error al ingresar costos')}!</p>
                            </MuiAlert>
                    </Snackbar>
                    <Snackbar 
                        className='w-100 p-0' 
                        onClose={() => setShowFailureFormula(false)} 
                        open={showFailureFormula} 
                        autoHideDuration={4000}>
                            <MuiAlert elevation={6} variant="filled" severity="warning">
                                <p className='text-center w-100 m-0'>¡{_('Debe ingresar una fórmula válida')}!</p>
                            </MuiAlert>
                    </Snackbar>
                    
                    <p>{_('Asignarás costos a todos los registros visibles en pantalla. Al asignar costos permites cuantificar el avance en base al costo')}.</p>
                    <Form method="POST" onSubmit={handleSubmit}>
                        {selectedCardsGroups==="none"?
                        <p>{_('Registros visibles')}: {visibleCardsGroupIds.length}</p>:
                        <p>{_('Registros seleccionados')}: {selectedCardsGroups.length}</p>}
                        <Form.Group controlId="unit">
                            <div className='d-flex flex-row'>
                                <InfoTooltip message={'unit of measure message'}></InfoTooltip>
                                <div className='ml-1'><Form.Label>{_('Unidad de medida')}:</Form.Label></div>
                            </div>
                            <Form.Control type="text" placeholder="kg, m², m³..." name="unit" required />
                        </Form.Group>

                        <Form.Group className='mt-2' controlId="input_type">
                            <div className='d-flex flex-row'>
                                <InfoTooltip message={'costs message'}></InfoTooltip>
                                <div className='ml-1'><Form.Label>{_('Tipo de Asignación')}:</Form.Label></div>
                            </div>
                            <Select name="input_type" required style={{backgroundColor:'#2a3038'}}>
                                <MenuItem value="total">{_('Costo Total')}</MenuItem>
                                <MenuItem value="unit">{_('Costo Unitario')}</MenuItem>
                            </Select>
                        </Form.Group>

                        <Form.Group className='mt-2' controlId="cost_amount">
                            <Form.Label>{_('Costo')}:</Form.Label>
                            <Form.Control type="number" step="any" name="cost_amount" min="0" required />
                        </Form.Group>

                        <Form.Group className='mt-2' controlId="formula">
                            <div className='d-flex flex-row'>
                                <InfoTooltip message={'formula message'}></InfoTooltip>
                                <div className='ml-1'><Form.Label>{_('Fórmula')} {'('}{_('Ponderador')}{')'}:</Form.Label></div>
                            </div>
                            <Form.Control type="text" name="formula" defaultValue="area" required />
                        </Form.Group>

                        <Form.Group className='mt-2' controlId="check">
                            <Form.Check
                            className='w-75'
                            type="checkbox" 
                            label={_('Que la cantidad sea el resultado de la fórmula')+'.'}
                            checked={isChecked}
                            onChange={handleCheckChange}
                            name="check"
                            />
                        </Form.Group>

                        <Form.Group className='mt-2' controlId="total_quantity">
                            <Form.Label>{_('Cantidad Total')}:</Form.Label>
                            <Form.Control 
                                type="number"
                                step="any"
                                name="total_quantity" 
                                min="0" 
                                required 
                                disabled={isChecked}
                                style={isChecked ? { backgroundColor: '#151515', color: '#434a54' } : null}/>
                        </Form.Group>

                        <div className='d-flex justify-content-center mt-3 mb-1'>
                            <div style={{ position: 'relative' }}>
                                <Button 
                                    size='small' 
                                    style={{ background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700 }} 
                                    type="submit">
                                    <p style={{fontFamily:"Rubik", margin:'0px'}}>{ _('Añadir Costos') }</p>
                                </Button>
                                {showLoading && 
                                    <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                        <CircularProgress style={{ width:'20px', height:'20px' }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddCosts